/* unplugin-vue-components disabled */import { render } from "./SysCogPage.vue?vue&type=template&id=15272e42&scoped=true"
import script from "./SysCogPage.vue?vue&type=script&lang=js"
export * from "./SysCogPage.vue?vue&type=script&lang=js"

import "./SysCogPage.vue?vue&type=style&index=0&id=15272e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15272e42"]])

export default __exports__